/**
 * The below file contains the action methods for fire class master.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import {
  GET_ALL_FIRE_CLASS,
  SET_ALL_FIRE_CLASS,
} from "redux/constants/FireClass";

//#region Action methods for fetching fire class

/**
 * Method for getting the fire class
 * @param {any} params Fire Data
 * @returns Json Object
 */
export const getAllFireClass = () => {
  return {
    type: GET_ALL_FIRE_CLASS,
  };
};

/**
 * Method for setting the fire class
 * @param {any} params Fire Data
 * @returns Json Object
 */
export const setAllFireClass = (data) => {
  return {
    type: SET_ALL_FIRE_CLASS,
    payload: data,
  };
};

//#endregion